import newsDiscoverItemImg1 from '../../assets/img/news/news-2.png';
import newsDiscoverItemImg2 from '../../assets/img/news/news-3.png';
import newsDiscoverItemImg3 from '../../assets/img/news/news-4.png';
import newsDiscoverItemImg4 from '../../assets/img/news/news-5.png';

export const mockData = [
    {
        img: newsDiscoverItemImg1,
        title: 'It is a long established fact that a reader will be distracted',
        date: 'OCT 15, 2020',
    },
    {
        img: newsDiscoverItemImg2,
        title: 'It is a long established fact that a',
        date: 'OCT 15, 2020',
    },
    {
        img: newsDiscoverItemImg3,
        title: 'It is a long established fact that a reader will be distracted',
        date: 'OCT 15, 2020',
    },
    {
        img: newsDiscoverItemImg4,
        title: 'It is a long established fact that a reader will be distracted',
        date: 'OCT 15, 2020',
    },
    {
        img: newsDiscoverItemImg2,
        title: 'It is a long established fact that a',
        date: 'OCT 15, 2020',
    },
    {
        img: newsDiscoverItemImg3,
        title: 'It is a long established fact that a reader will be distracted',
        date: 'OCT 15, 2020',
    },
];
